import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SmileyPiercingImage from '../../Assets/Piercing Services/smiley piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SmileyPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Smiley Piercing UAE | 150-200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Smiley Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Smiley Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SmileyPiercingImage} alt="Smiley Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Smiley Piercing</h3>

          <p>
            Add a subtle yet playful touch to your style with our professional smiley piercing services in the UAE, available at an affordable price range of 150–200 AED. Smiley piercing is a unique and trendy option placed on the small tissue (frenulum) inside the upper lip, making it a hidden piercing that becomes visible only when you smile. This makes it a perfect choice for individuals who want a discreet yet eye-catching form of self-expression. Whether you’re looking for something different or a fun addition to your piercing collection, our expert specialists ensure precise placement for a comfortable and stylish result.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and comfort above all else. Our certified professionals use sterile, single-use, high-quality equipment to perform each smiley piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe experience for every client. Our goal is to provide a quick, smooth, and pain-minimized procedure, making your smiley piercing experience as comfortable and stress-free as possible.
          </p>

          <p>
            Smiley piercing is ideal for those who prefer a more subtle and personal style statement. Since it remains hidden most of the time, it offers a unique balance between discretion and individuality. When you smile, the jewelry becomes visible, adding a charming and unexpected detail that enhances your overall look. Our specialists take the time to understand your preferences and guide you in selecting the right jewelry style, ensuring it complements your personality while maintaining comfort.
          </p>

          <p>
            The procedure is quick and typically completed within minutes, making it convenient even for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, allowing you to enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic jewelry options that are safe for sensitive oral tissues, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that you feel relaxed throughout your visit. We understand that oral piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and comfortable experience.
          </p>

          <p>
            Aftercare is especially important for smiley piercings, and we provide detailed instructions to help you maintain proper hygiene during the healing process. Our specialists will guide you on cleaning routines, oral care practices, and precautions to avoid irritation or infection. Following proper aftercare ensures faster healing and helps maintain the health of your piercing.
          </p>

          <p>
            Our smiley piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is simple and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted smiley piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, advanced techniques, and a focus on customer satisfaction, we help you achieve a unique and playful look effortlessly. Book your smiley piercing appointment today and reveal your style with confidence every time you smile.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Smiley Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SmileyPiercing;